import React, { useState, useEffect } from "react";
import { MdOutlineArrowRightAlt, MdEmail } from "react-icons/md";
import {
    FaFacebookF,
    FaPinterestP,
    FaTwitter,
    FaLinkedinIn,
    FaAddressCard,
} from "react-icons/fa";
import { BiSolidPhoneCall } from "react-icons/bi";
import { Link, NavLink } from "react-router-dom";
import { scroller } from 'react-scroll';
import footerImage from "../../assets/Logo.jpg";

const HoaFooter = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleScroll = (to) => {
        if (window.location.pathname !== '/') {
            window.location.href = `/#${to}`;
        } else {
            scroller.scrollTo(to, {
                smooth: true,
                duration: 500,
                offset: -100
            });
        }
    };

    // Shared class strings for consistency
    const linkClasses = "no-underline text-white hover:text-blue-200 transition-colors duration-200";
    const headingClasses = "text-xl mb-2.5 text-white font-semibold";
    const textClasses = "text-white text-lg font-normal";
    const iconClasses = "text-white font-bold";

    return (
        <div className="bg-blue-800 py-8">
            <div className="flex flex-col md:flex-row justify-between items-start w-4/5 max-w-7xl mx-auto gap-8 md:gap-0">

                {/* Logo and Social Section */}
                <div className="w-full md:w-1/2 flex flex-col gap-6">
                    <div className="footer-logo">
                        <img src={footerImage} alt="logo" className="w-[94px] md:w-[150px] md:relative md:-left-6" style={{ filter: "brightness(100)", scale: 2 }} />
                    </div>

                    <Link
                        to="/"
                        className={`${linkClasses} flex items-center font-bold text-lg`}
                    >
                        Read more
                        <MdOutlineArrowRightAlt className="text-base ml-1" />
                    </Link>

                    <div className="flex gap-3">
                        {[
                            { to: "/facebook", Icon: FaFacebookF },
                            { to: "/twitter", Icon: FaTwitter },
                            { to: "/pinterest", Icon: FaPinterestP },
                            { to: "/linkedin", Icon: FaLinkedinIn }
                        ].map(({ to, Icon }) => (
                            <NavLink
                                key={to}
                                to={to}
                                className="flex justify-center items-center text-white hover:text-blue-200 transition-colors duration-200"
                            >
                                <Icon className="cursor-pointer text-2xl" />
                            </NavLink>
                        ))}
                    </div>
                </div>

                {/* Navigation Sections */}
                <div className="w-full md:w-1/2 flex justify-between flex-col-reverse md:flex-row gap-8 md:gap-4">

                    {/* Vendor Section - Hidden on mobile */}
                    <div className="flex flex-col items-start gap-2.5 pt-[35px]">
                        <h3 className={headingClasses}>Vendor</h3>
                        <Link
                            to="/hoa-member"
                            onClick={scrollToTop}
                            className={`${linkClasses} block mb-1 ${textClasses}`}
                        >
                            Member Onboard
                        </Link>
                        <Link
                            to="/hoa-vendor-onBoarding"
                            onClick={scrollToTop}
                            className={`${linkClasses} block mb-1 ${textClasses}`}
                        >
                            Vendor Onboard
                        </Link>
                    </div>

                    {/* Company Section */}
                    <div className="flex flex-col items-start gap-2.5 pt-[35px]">
                        <h3 className={headingClasses}>Company</h3>
                        {[
                            { label: "Services", target: "hoa-offer" },
                            { label: "Pricing", target: "hoa-plan" },
                            { label: "Testimonial", target: "hoa-testimonial" },
                            { label: "Contact", target: "hoa-contact" }
                        ].map(({ label, target }) => (
                            <a
                                key={target}
                                onClick={() => handleScroll(target)}
                                className={`${linkClasses} block mb-1 ${textClasses} cursor-pointer`}
                            >
                                {label}
                            </a>
                        ))}
                    </div>

                    {/* Contact Section */}
                    <div className="flex flex-col items-start gap-2.5 pt-[35px]">
                        <h3 className={headingClasses}>Get In Touch</h3>

                        <Link
                            to="mailto:contact@vhoas.com"
                            className={`${linkClasses} flex items-center gap-2.5 ${textClasses}`}
                        >
                            <MdEmail className={iconClasses} />
                            contact@vhoas.com
                        </Link>

                        {/* <Link
                            to="tel:+14151234123"
                            className={`${linkClasses} flex items-center gap-2.5 ${textClasses}`}
                        >
                            <BiSolidPhoneCall className={iconClasses} />
                            +1 (415) 123-4123
                        </Link> */}

                        <p className={`flex items-center gap-2.5 ${textClasses} m-0`}>
                            <FaAddressCard className={iconClasses} />
                            San Francisco, USA
                        </p>
                    </div>
                </div>
            </div>

            {/* Divider */}
            <div className="h-[0.3px] w-4/5 max-w-7xl my-6 mx-auto bg-white opacity-30"></div>

            {/* Copyright */}
            <div className="w-4/5 max-w-7xl mx-auto text-start">
                <p className={`${textClasses} m-0`}>
                    Copyright © 2024 VHOAs., All rights reserved.
                </p>
            </div>
        </div>
    );
};

export default HoaFooter;